import * as React from 'react'

import { F0DatePicker } from '@factorialco/f0-react'
import type { DatePickerValue } from '@factorialco/f0-react/dist/experimental'

import FormRow from 'modules/core/components/FormRow'
import { useMemo } from 'modules/core/hooks/useMemo'
import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'

interface Props {
  form: ReportsForm
}

const ReferenceDate = ({ form }: Props) => {
  const field = form.get('reference_date')

  const minDate = useMemo(() => {
    const date = new Date()
    date.setFullYear(date.getFullYear() - 10)
    date.setMonth(0, 1)
    return date
  }, [])

  const maxDate = useMemo(() => {
    const date = new Date()
    date.setFullYear(date.getFullYear() + 2)
    date.setMonth(11, 31)
    return date
  }, [])

  const dateValue = React.useMemo(() => {
    if (!field.value) return undefined
    const date = stringToDate(field.value, 'ui')
    return {
      granularity: 'day' as const,
      value: {
        from: date.toDate(),
        to: date.toDate(),
      },
    }
  }, [field.value])

  const handleDateChange = (
    date: DatePickerValue | undefined,
    _stringValue?: string | undefined
  ) => {
    if (date?.value?.from) {
      const formattedDate = i18nDateToString(date.value.from, 'ui')
      field.set(formattedDate)
    }
  }

  return (
    <FormRow>
      <F0DatePicker
        label={i18n.t('employees.reports.reference_date')}
        onChange={handleDateChange}
        size="sm"
        value={dateValue}
        minDate={minDate}
        maxDate={maxDate}
      />
    </FormRow>
  )
}

export default ReferenceDate
